import React from "react"
import { TreeMenuChildren } from "react-simple-tree-menu"
import {
  List,
  Input,
  Box,
  Text,
  Flex,
  ListItem,
  ListIcon,
  ListItemProps,
} from "@bianic-ui/core"
import { FaChevronRight, FaChevronDown } from "react-icons/fa"
import { TreeMenuItem } from "react-simple-tree-menu"

export interface ItemProps extends TreeMenuItem {
  iconSize?: number
  defaultPadding?: number
  levelSpace?: number
  parentBorder?: string | any
  parentHighlight?: string | any
  cursor?: any
  openedIcon?: JSX.Element | string
  closedIcon?: JSX.Element | string
}

export type TreeItemProps = ListItemProps & ItemProps

export const TreeItem: React.FC<TreeItemProps> = ({
  hasNodes = false,
  isOpen = false,
  level = 0,
  label = "unknown",
  active,
  onClick,
  toggleNode,
  focused,
  openedIcon = <ListIcon my="auto" as={FaChevronDown} color="#21BA45" />,
  closedIcon = <ListIcon my="auto" as={FaChevronRight} color="#CBD0E0" />,
  iconSize = 2,
  defaultPadding = 8,
  levelSpace = 24,
  cursor = "pointer",
  parentBorder = "3px",
  parentHighlight = "linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #21BA45;",
  style = {},
  openNodes,
  searchTerm,
  ...rest
}) => {
  const ICON_SIZE = iconSize
  const DEFAULT_PADDING = defaultPadding
  const LEVEL_SPACE = levelSpace
  const bgColorOpen: string = level === 0 && isOpen ? parentHighlight : "none"
  const radius: string = isOpen && level === 0 ? parentBorder : "0px"

  const handleClick = (e: any) => {
    hasNodes && toggleNode && toggleNode()
    e.stopPropagation()
  }

  return (
    <>
      <ListItem
        cursor="pointer"
        style={{
          paddingLeft:
            DEFAULT_PADDING +
            level * LEVEL_SPACE +
            ICON_SIZE * (hasNodes ? 0 : 12),
        }}
        display="flex"
        onClick={handleClick}
        _focus={{ shadow: "sm", outline: "none", zIndex: 999 }}
        _active={{ backgroundColor: "#21BA4540", outline: "none" }}
        {...rest}
      >
        {hasNodes && (isOpen ? openedIcon : closedIcon)}
        <Box as={Flex} h="1.5em" my="3px">
          <Text
            background={bgColorOpen}
            rounded={radius}
            px={level === 0 ? ICON_SIZE : 0}
          >
            {" "}
            {label}{" "}
          </Text>
        </Box>
      </ListItem>
    </>
  )
}

export const defaultChildren: TreeMenuChildren = ({ search, items }) => {
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    search && search(value)
  }
  return (
    <>
      {search && (
        <Input
          className="rstm-search"
          aria-label="Type and search"
          type="search"
          placeholder="Type and search"
          onChange={onSearch}
        />
      )}
      <List>
        {items.map(({ key, ...props }) => (
          <TreeItem key={key} {...props} />
        ))}
      </List>
    </>
  )
}
